import { Pipe, PipeTransform } from "@angular/core";
import { VenueData } from "../shared/model/venue";

@Pipe({
    name: "venueInlineAddress",
})
export class VenueInlineAddressPipe implements PipeTransform {
    transform(venue: VenueData, arg?: boolean): any {
        let result = "";

        if (venue) {
            let values = [
                venue.data.attributes.address1,
                venue.data.attributes.address2,
                venue.data.attributes.town,
            ];

            if (!arg) values.push(venue.data.attributes.postcode);

            result = values.join(",").replace(/[,]+/g, ", ");
        }

        return result;
    }
}
